import './ServiceStatusSettings.scss';
import { useState, useContext } from 'react';
import ServiceStatusContext from '../../../../Context/ServiceStatusContext';
import StatusService from '../../../../Services/StatusService';
import ServiceStatusTable from '../ServiceStatusTable/ServiceStatusTable';
import ServiceStatusMessageModal from '../Modals/ServiceStatusMessageModal';

/* eslint-disable react/prop-types */
export default function ServiceStatusSettings({ t }) {
  const [showCreateMessageModal, setShowCreateMessageModal] = useState(false);
  const [serviceStatusMessages] = useContext(ServiceStatusContext);

  // MESSAGE RELOADING IS NOW HANDLED BY SIGNALR

  /* const reloadMessages = async () => {
    await StatusService.getServiceStatusMessages()
      .then((response) => {
        setServiceStatusMessages(response.data);
      })
      .catch(() => {
        setServiceStatusMessages([]);
      });
  }; */

  const deleteMessage = async (id) => {
    await StatusService.deleteServiceStatusMessage(id)
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        // reloadMessages();
      });
  };

  return (
    <div className="service-status-settings-container">
      <ServiceStatusTable
        onAddClick={() => setShowCreateMessageModal(true)}
        t={t}
      >
        {serviceStatusMessages.map((message) => (
          <ServiceStatusTable.Item
            key={message.id}
            message={message}
            onDeleteClick={async (e) => {
              await deleteMessage(e);
            }}
            t={t}
          />
        ))}
      </ServiceStatusTable>
      {showCreateMessageModal && (
        <ServiceStatusMessageModal
          handleClose={() => setShowCreateMessageModal(false)}
          onCreateMessage={async () => {
            setShowCreateMessageModal(false);
            // await reloadMessages();
          }}
          t={t}
        />
      )}
    </div>
  );
}
